import React, {useEffect} from "react";
import AppContainer from "../AppContainer/AppContainer";
import {Col, Container, Row} from "react-bs4grid";
import {NavLink, Route, Switch} from "react-router-dom";

import CustomContentProgressBar from "./CustomContentProgressBar";
import useAppState from "../../common/StateMachine/useAppState";
import MyJobs from "./MyJobs";
import BrowseNew from "./BrowseNew";

import "./jobs.scss";
import {useTranslation} from "react-i18next";

const Jobs = () => {
    const jobsState = useAppState("jobs");
    const {t} = useTranslation();

    useEffect(() => {
        jobsState.getCommitmentSummary();
    }, []);

    function getAmountToGo() {
        const amountCommitted = jobsState.state.commitmentSummary.overallAmountCommitted;
        const amountCollected = jobsState.state.commitmentSummary.overallAmountCollected;

        if (amountCommitted == null || amountCollected == null) {
            return 0;
        } else {
            const amountLeft = amountCommitted - amountCollected;
            return amountLeft < 0 ? 0 : amountLeft;
        }
    }

    function getCommitted() {
        return jobsState.state.commitmentSummary.overallAmountCommitted;
    }

    function getTotalCollected() {
        return jobsState.state.commitmentSummary.overallAmountCollected == null ? 0 : jobsState.state.commitmentSummary.overallAmountCollected;
    }

    function getJobCount() {
        const jobs = jobsState.state.jobs.data &&
            jobsState.state.jobs.data.filter(job => {
                return (
                    job.userCommitment.totalAmountCollected <
                    job.userCommitment.totalAmountCommitted
                );
            });
        return jobs ? jobs.length : 0;
    }

    return (
        <AppContainer>
            <Container className="mt-16">
                <Row className="pb-16" justifyContent="center" alignItems="center">
                    <Col w="auto">
                        <h1>{t("jobs")}</h1>
                    </Col>
                </Row>
                <Row justifyContent="center" alignItems="center">
                    <Col w="6">
                        <NavLink
                            className="tabbed-nav-item"
                            activeClassName="active"
                            to="/jobs/my-jobs"
                        >
                            <h4 className="pt-16 pb-16">{t("myJobs")}</h4>
                        </NavLink>
                    </Col>
                    <Col w="6">
                        <NavLink
                            className="tabbed-nav-item"
                            activeClassName="active"
                            to="/jobs/browse-new"
                        >
                            <h4 className="pt-16 pb-16">{t("browseNew")}</h4>
                        </NavLink>
                    </Col>
                </Row>
            </Container>
            <Route
                path="/jobs/my-jobs"
                render={() => {
                    const summaryPercentage =
                        ((jobsState.state.commitmentSummary.overallAmountCollected + 0.01) /
                            jobsState.state.commitmentSummary.overallAmountCommitted) *
                        100;
                    return (
                        <Container fluid className="jobs-statistics pt-32 pb-32">
                            <Row justifyContent="center" alignItems="center">
                                <Col
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-around",
                                        alignItems: "center"
                                    }}
                                    sm={{
                                        size: 12
                                    }}
                                    md={{
                                        size: 8
                                    }}>
                                        <div className="statOuter">
                                            <div className="statMiddle">
                                                <div className="statInner">
                                                    <span>{t("jobsInProgress")}</span>
                                                    <h3>
                                                        {getJobCount()}
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="statOuter">
                                            <div className="statMiddle">
                                                <div className="statInner">
                                                    <span>{t("committedToCollect")}</span>
                                                    <h3>
                                                        {getCommitted()} kg
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="statOuter">
                                            <div className="statMiddle">
                                                <div className="statInner">
                                                    <span>{t("collected")}</span>
                                                    <h3>
                                                        {getTotalCollected()} kg
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                </Col>
                            </Row>
                        </Container>
                    );
                }}
            />
            <Switch>
                <Route path="/jobs/my-jobs" component={MyJobs}/>
                <Route path="/jobs/browse-new" component={BrowseNew}/>
            </Switch>
        </AppContainer>
    );
};

export default Jobs;
